/** A demanded reviewPreview answer from the Mate; source values stay in account memory. */
import { WS_METHODS } from "@t3tools/contracts";
import type { EnvironmentRpcSuccess } from "../../rpc/client.ts";
import type { FamilySpec } from "./spec.ts";
declare module "../model.ts" {
  interface FamilyValues {
    readonly mateReview: EnvironmentRpcSuccess<typeof WS_METHODS.reviewGetDiffPreview>;
  }
}
export const mateReviewFamily: FamilySpec<"mateReview"> = {
  family: "mateReview",
  authority: "mate",
  scope: {
    source: "mate",
    suffix: "workspace-reviewPreview",
    leaving: "removed",
    demand: "detail",
    mode: "once",
  },
};
